import { apiClient, getErrorMessage } from '@/lib/apiClient';

export interface TranslationItemDto {
  category: string;
  entityId: string;
  entityDisplayName: string;
  field: string;
  fieldDisplayName: string;
  sourceValue: string | null;
  targetValue: string | null;
}

export interface GetTranslationsParams {
  language: string;
  category?: string;
  missingOnly?: boolean;
  skipCount?: number;
  maxResultCount?: number;
}

export interface UpdateTranslationItemParams {
  language: string;
  category: string;
  entityId: string;
  field: string;
  value: string | null;
}

export interface PagedResult<T> {
  items: T[];
  totalCount: number;
}

class TranslationManagementService {
  async getList(params: GetTranslationsParams): Promise<PagedResult<TranslationItemDto>> {
    try {
      const response = await apiClient.get<PagedResult<TranslationItemDto>>(
        '/api/core/translations',
        { params }
      );
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  }

  async update(data: UpdateTranslationItemParams): Promise<void> {
    try {
      await apiClient.put('/api/core/translations', data);
    } catch (error) {
      throw error;
    }
  }
}

export const translationManagementService = new TranslationManagementService();
